const INSTALL_HASH_KEY = 'dealer_install_hash'
const DEVICE_ID_KEY = 'dealer_device_id'
const EMAIL_KEY = 'dealer_email'

export function getInstallHash(): string {
  let hash = localStorage.getItem(INSTALL_HASH_KEY)
  if (hash === null || hash === '') {
    hash = crypto.randomUUID().replace(/-/g, '').slice(0, 8)
    localStorage.setItem(INSTALL_HASH_KEY, hash)
  }
  return hash
}

export function getDeviceId(): string | null {
  const storedDeviceId = localStorage.getItem(DEVICE_ID_KEY)
  if (storedDeviceId !== null && storedDeviceId !== '') {
    return storedDeviceId
  }

  const email = localStorage.getItem(EMAIL_KEY)
  if (email === null || email === '') {
    return null
  }

  const deviceId = `${email.toLowerCase()}_${getInstallHash()}`
  localStorage.setItem(DEVICE_ID_KEY, deviceId)
  return deviceId
}
